const superTiny = "4px"
const tiny = "8px"
const small = "16px"
const base = "32px"
const medium = "40px"
const large = "64px"

export default {
  superTiny,
  tiny,
  small,
  base,
  medium,
  large
}
